const defaults = {
	titles: {
		componentTitle: "Logg inn på Online e-post",
		loggedInTitle: "Online e-post",
		loggedInDescription:
			"Du er allerede logget inn med din Telenor ID, så om du ønsker å gå til Online e-post trykker du bare på knappen nedenfor. Derfra går du bare gjennom et lite steg til før du er inne på din e-postkonto.",
	},
	form: {
		loginButtonText: "Logg inn",
		loggingInButtonText: "Logger inn",
		forgotPasswordText: "Glemt passord?",
		forgotPasswordUrl: "/kundeservice/e-post/glemt-passord/",
	},
	buttonsAndLinks: {
		loginWithTelenorIdText: "Logg inn med Telenor ID",
		loginButtonText: "Logg inn",
		loggingInButtonText: "Logger inn",
		goToEpostText: "Gå til Online e-post",
		logoutText: "Logg ut",
		forgotPasswordText: "Glemt passord?",
		forgotPasswordUrl: "/kundeservice/e-post/glemt-passord/",
	},
	separators: {
		separatorText: "eller med",
		separatorTextWhenLoggedIn: "eller",
	},
	loginInfoBox: {
		loginInfoBoxTitle: "Husker ikke nettleseren din brukernavn og passord?",
		loginInfoBoxIngress: "",
		loginInfoBoxUrl: "/kundeservice/e-post/",
		openInfoBoxInSameTab: false,
		loginInfoBoxUrlText: "Få hjelp her",
	},
	errors: {
		errorInvalidCredentials: "Feil e-post og/eller passord.",
		telenorIdLoginError: "Kunne ikke logge inn med Telenor ID. Prøv igjen senere.",
		telenorIdLogoutError: "Kunne ikke logge ut. Prøv igjen senere.",
	},
};

export default defaults;
